/**
 * Type guards for token configuration
 */
import { AssetHubToken, FiatToken, TokenType } from '../types/base';
import { EvmToken } from '../types/evm';
/**
 * Type guard for EVM tokens
 */
export function isEvmTokenDetails(token) {
    return token.type === TokenType.Evm;
}
/**
 * Type guard for AssetHub tokens
 */
export function isAssetHubTokenDetails(token) {
    return token.type === TokenType.AssetHub;
}
/**
 * Type guard for Stellar tokens
 */
export function isStellarTokenDetails(token) {
    return token.type === TokenType.Stellar;
}
/**
 * Type guard for Moonbeam tokens
 */
export function isMoonbeamTokenDetails(token) {
    return token.type === TokenType.Moonbeam;
}
/**
 * Type guard for on-chain tokens
 */
export function isOnChainTokenDetails(token) {
    return isEvmTokenDetails(token) || isAssetHubTokenDetails(token);
}
/**
 * Type guard for fiat tokens
 */
export function isFiatTokenDetails(token) {
    return isStellarTokenDetails(token) || isMoonbeamTokenDetails(token);
}
/**
 * Type guard for Stellar output token details
 */
export function isStellarOutputTokenDetails(tokenDetails) {
    return tokenDetails.type === TokenType.Stellar;
}
/**
 * Type guard for Moonbeam output token details
 */
export function isMoonbeamOutputTokenDetails(outputTokenDetails) {
    return outputTokenDetails.type === TokenType.Moonbeam;
}
export function isFiatToken(token) {
    return Object.values(FiatToken).includes(token.toLowerCase());
}
export function isAssetHubToken(token) {
    return Object.values(AssetHubToken).includes(token.toLowerCase());
}
export function isEvmToken(token) {
    return Object.values(EvmToken).includes(token.toLowerCase());
}
export function isOnChainToken(token) {
    return isEvmToken(token) || isAssetHubToken(token);
}
